/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  addItemCategoriesData,
  getItemCategoriesById,
  updateItemCategoriesData,
} from "utils/api";
import { getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
import PlanCard from "./Plan";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let SCREEN_RIGHT;
let fetchedItemCategories;
let routePath = "";
let paramID = undefined;
let parentScreen = undefined;

function AddItemCategory() {
  const { id } = useParams();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [screenName, setScreenName] = useState("Add New Account");
  const [loading, setLoading] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [categoryNameErr, setCategoryNameErr] = useState(false);
  const [categoryCodeErr, setCategoryCodeErr] = useState(false);
  const [categoryStatusErr, setCategoryStatusErr] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [values, setValues] = useState({
    categoryName: "",
    categoryCode: "",
    categoryStatus: "Active",
    categoryHeadID: undefined,
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
    searchParameterList: ["categoryName", "categoryCode", "categoryStatus"],
  });

  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    const paramValue = new URLSearchParams(window.location.search).get("new");
    paramID = new URLSearchParams(window.location.search).get("id");
    parentScreen = new URLSearchParams(window.location.search).get("for");

    routePath = paramValue ? "/expenses/addExpenses" : "/itemCategory";
    switch (paramValue) {
      case "expense":
        routePath = "/expenses/addExpenses";
        break;
      case "item":
        routePath = `/items/addItems?${
          paramID ? `new=${parentScreen}&id=${paramID}` : ""
        }`;
        break;

      default:
        routePath = "/itemCategory";
        break;
    }
    id === undefined
      ? setScreenName("Add New Account")
      : setScreenName("Edit Account");
    (async () => {
      getRight();
      if (id !== undefined) {
        values._id = id;
        getItemCategoriesById(
          { _id: id },
          (data) => {
            if (data.Result_Output.length > 0) {
              fetchedItemCategories = data.Result_Output[0];
              setValues(fetchedItemCategories);
            }
          },
          dispatch
        );
      }
    })();
  }, [dispatch]);

  async function getRight() {
    let right = await getScreenRight("Categories");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const clearErrorStates = () => {
    setCategoryNameErr(false);
    setCategoryCodeErr(false);
    setCategoryStatusErr(false);
  };

  const handleAddData = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag =
      validateField(values.categoryName, setCategoryNameErr) || mandateFlag;
    mandateFlag =
      validateField(values.categoryCode, setCategoryCodeErr) || mandateFlag;
    mandateFlag =
      validateField(values.categoryStatus, setCategoryStatusErr) || mandateFlag;

    if (mandateFlag) {
      return;
    }

    const apiFunction =
      id === undefined ? addItemCategoriesData : updateItemCategoriesData;

    apiFunction(
      values,
      (data) => {
        if (data.Result_Status) {
          showResMsg(
            id === undefined ? genericMessage.added : genericMessage.updated,
            1000,
            data.Result_Status,
            navigate,
            routePath
          );
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      },
      dispatch
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={6} mb={3}>
            <Grid
              container
              spacing={1}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item lg={12} xs={12}>
                {/* <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox> */}
                <MDBox>
                  <Grid container px={2} py={2} spacing={3}>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Account Name"
                        variant="outlined"
                        fullWidth
                        autoFocus={true}
                        inputProps={{
                          maxLength: 30,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          autoCompleted: "new-password",
                          className: "custom-fieldtext",
                        }}
                        value={values.categoryName}
                        onChange={handleChange("categoryName")}
                      />
                      {categoryNameErr ? (
                        <span style={errMsg}>Account Name can't be blank</span>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Account Code"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 10,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext",
                        }}
                        value={values.categoryCode}
                        onChange={handleChange("categoryCode")}
                      />
                      {categoryCodeErr ? (
                        <span style={errMsg}>Account Code can't be blank</span>
                      ) : (
                        ""
                      )}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ height: "35.11px" }}
                          label="Status"
                          // disabled
                          onChange={handleChange("categoryStatus")}
                          value={values.categoryStatus}
                        >
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                        {categoryStatusErr ? (
                          <span style={errMsg}> Status can't be blank</span>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <Grid
                  container
                  // mt={2}
                  pb={3}
                  // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
                  alignItems="center"
                  spacing={2}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Grid item xs={12} md={4} spacing={2} lg={1.68}>
                    <Link to={routePath}>
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"
                        fullWidth
                        style={{ height: "40px" }}
                      >
                        Cancel
                      </MDButton>
                    </Link>
                  </Grid>
                  <Grid item xs={12} md={4} spacing={2} lg={1.68}>
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      fullWidth
                      onClick={handleAddData}
                      disabled={SCREEN_RIGHT === "View Only"}
                      style={{ height: "40px" }}
                    >
                      {id !== undefined ? <>Update</> : <>Save</>}
                    </MDButton>
                  </Grid>
                </Grid>
                {/* </Card> */}
              </Grid>
            </Grid>
          </MDBox>
        </Card>
        {/* <PlanCard /> */}
      </div>
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default AddItemCategory;
